import React from 'react'

const PropsList = ({systemProps}) => <div>{systemProps.propNames.join(', ')}</div>

export default PropsList
